import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const BookingsTable = ({ bookings }) => {
  console.log("BookingsTable rendered with bookings:", bookings);
  const { t } = useTranslation("dashboard");
    const navigate = useNavigate();
  const handleRowClick = (bookingId) => {
    navigate(`/orders/${bookingId}`);
  };
  const getStatusDisplayName = (status) => {
    const statusLower = status.toLowerCase();

    // Map API status values to translation keys
    const statusTranslationMap = {
      accepted: "confirmed",
      pending: "pendingPayment",
      paid: "paid",
      no_responded: "noResponded",
      processing: "processing",
      shipped: "shipped",
      delivered: "delivered",
      rejected: "rejected",
      cancelled: "cancelled"
    };

    const translationKey = statusTranslationMap[statusLower];
    if (translationKey) {
      return t(`statuses.${translationKey}`);
    }

    // Fallback for unknown statuses
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  const getStatusBadgeClass = (status) => {
    const statusLower = status.toLowerCase();

    if (["accepted", "delivered", "paid"].includes(statusLower)) {
      return "confirmed-orders";
    }
    if (statusLower === "rejected") {
      return "rejected";
    }
      if (statusLower === "cancelled") {
      return "rejected";
    }
    if (statusLower === "pending") {
      return "pending-orders";
    }
    if (statusLower === "no_responded") {
      return "pending-orders";
    }
    if (["pending-payment", "processing", "shipped"].includes(statusLower)) {
      return "nostatus-orders";
    }
    return "";
  };

  if (!bookings || bookings.length === 0) {
    return (
      <div className="dashboard-table">
        <h2 className="dashboard-subtitle">
          {t("bookingsTable.latestOrders")}
        </h2>
        <table>
          <thead>
            <tr>
              <th>{t("bookingsTable.orderNumber")}</th>
              <th>{t("bookingsTable.company")}</th>
              <th>{t("bookingsTable.cost")}</th>
              <th>{t("bookingsTable.status")}</th>
              <th>{t("bookingsTable.action")}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                {t("bookingsTable.noBookings")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="dashboard-table">
      <div className="head-table-order">
        <h2 className="dashboard-subtitle">
          {t("bookingsTable.latestOrders")}
        </h2>
        <NavLink to="/orders" className="all-orders">
          {t("bookingsTable.allOrders")}
        </NavLink>
      </div>
      <table>
        <thead>
          <tr>
            <th>{t("bookingsTable.orderNumber")}</th>
            <th>{t("bookingsTable.company")}</th>
            <th>{t("bookingsTable.cost")}</th>
            <th>{t("bookingsTable.status")}</th>
            <th>{t("bookingsTable.action")}</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((booking) => (
            <tr key={booking.id} >
              <td>{booking.id}</td>
              <td>{booking.company}</td>
              <td>{booking.cost}</td>
              <td>
                <span
                  className={`status-badge ${getStatusBadgeClass(
                    booking.status
                  )}`.trim()}
                >
                  {getStatusDisplayName(booking.status)}
                </span>
              </td>
              <td className="more-circle2" onClick={() => handleRowClick(booking.id)}>
                <img src="/more-circle2.svg" alt={t("bookingsTable.action")} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BookingsTable;
